<div *ngIf="consultationProcessSearchResults.length > 0">
    <h2>Suchergebnisse</h2>
    <div class="table-responsive">
        <table class="table table-condensed table-bordered table-striped">
            <thead>
                <tr>
                    <th>Partner</th>
                    <th>Agentur</th>
                    <th>Geburtsdatum</th>
                    <th>Status</th>
                    <th>Vorgangsnr.</th>
                    <th>Beratungsanlass</th>
                    <th>Produkte</th>
                    <th>Erstellt</th>
                    <th>Abgeschl.</th>
                    <th>Aktionen</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let result of consultationProcessSearchResults">
                    <td class="partner">{{ result.CustomerName }}</td>
                    <td class="agent">
                        {{ result.AgencyNumber }} {{ result.AgencyName }}
                    </td>
                    <td class="birthdate">
                        {{
                            moment(result.CustomerBirthdate).format(
                                "DD.MM.YYYY"
                            )
                        }}
                    </td>
                    <td class="status">
                        {{ result.IsFinished ? "Geschlossen" : "Offen" }}
                    </td>
                    <td class="offer-ids">{{ result.OfferIds }}</td>
                    <td class="consultation-occasion">
                        {{
                            ZASConstants.ConsultationOccasionTable[
                                result.Occasion
                            ]
                        }}
                    </td>
                    <td class="product">{{ result.Lines }}</td>
                    <td class="start-date">
                        {{ moment(result.CreatedOn).format("DD.MM.YYYY") }}
                    </td>
                    <td class="finalisation-date">
                        {{
                            !result.FinalizedOn
                                ? ""
                                : moment(result.FinalizedOn).format(
                                      "DD.MM.YYYY"
                                  )
                        }}
                    </td>
                    <td class="expand">
                        <a [routerLink]="['/', result.ConsultationProcessId]">
                            <img
                                class="process-expansion-icon clickable"
                                src="/zbd/img/expand.png"
                                title="Vorgang bearbeiten"
                            />
                        </a>
                        <a
                            *ngIf="result.IsFinished"
                            (click)="downloadDocument(result.DocumentId)"
                        >
                            <img
                                class="process-expansion-icon clickable"
                                src="/zbd/img/pdf.png"
                                title="Gedrucktes Dokument öffnen"
                            />
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <button
        *ngIf="moreResults"
        [disabled]="searching"
        type="button"
        (click)="searchMore()"
        class="zas-button"
    >
        <span class="button-label">Weitere Ergebnisse</span>
    </button>
</div>
